import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { Provider } from "react-redux";
import { store, persistor } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
import { StepLabelsProvider } from "./context/StepLabelsContext";
import "./index.css";
import "./tailwind.css";
import "./tailwind.generated.css";

ReactDOM.render(
    <Provider store={store}>
        <PersistGate loading="null" persistor={persistor}>
            <StepLabelsProvider>
                <App />
            </StepLabelsProvider>
        </PersistGate>
    </Provider>,
    document.getElementById("root")
);
